import { formatImages } from "../../../lib/images";
import {
  KontentLinkedSummary,
  KontentTaxonomy,
  StringValue,
} from "../../../types";

export interface ArticleListingItems {
  items: {
    name: string;
    codename: string;
    articles: {
      elements: {
        content: {
          value: {
            elements: {
              summary: KontentLinkedSummary;
            };
          }[];
        };
        knowledge_center: KontentTaxonomy;
        title: StringValue;
        url: {
          url: string;
        };
        display_publish_date: Date;
      };
      system: {
        last_modified: Date;
      };
    }[];
  }[];
}

export function extractCategories(items: ArticleListingItems["items"]) {
  return items.map((item) => {
    return {
      name: item.name,
      articles: item.articles.map((article) => {
        const image =
          article.elements.content?.value[0]?.elements?.summary?.value[0]
            ?.elements?.image?.value[0]?.elements;
        let formattedImages = null;

        if (image) {
          formattedImages = formatImages(image);
        }

        return {
          title: article.elements.title.value,
          url: article.elements.url.url,
          image: formattedImages?.largeImage,
        };
      }),
    };
  });
}
